import { gql, type TypedDocumentNode } from "@apollo/client";
import type { CommissionFundingBatchNode } from "@/pages/billing/finance/commission/funding/types";
import type { CommissionPartnerNode, CommissionPartnerStatus } from "./types";

export interface CreateCommissionPartnerInput {
  name: string;
  legacyId: string;
  status: CommissionPartnerStatus;
}

export interface CreateCommissionPartnerResponse {
  commissionCreatePartner: {
    partner: CommissionPartnerNode;
  };
}

export const CREATE_COMMISSION_PARTNER_MUTATION: TypedDocumentNode<
  CreateCommissionPartnerResponse,
  { input: CreateCommissionPartnerInput }
> = gql`
  mutation CreateCommissionPartner($input: CreateCommissionPartnerInput!) {
    commissionCreatePartner(input: $input) {
      partner {
        id
        name
        legacyId
        status
      }
    }
  }
`;

export interface SaveCommissionFundingDraftResponse {
  commissionSaveFundingDraft: {
    success: boolean;
    message: string;
    fundingBatch: CommissionFundingBatchNode | null;
  };
}

export interface SaveCommissionFundingDraftVariables {
  partnerId: string;
  lineIds: string[];
  idempotencyKey: string;
}

export const SAVE_COMMISSION_FUNDING_DRAFT_MUTATION: TypedDocumentNode<
  SaveCommissionFundingDraftResponse,
  SaveCommissionFundingDraftVariables
> = gql`
  mutation SaveCommissionFundingDraft($partnerId: ID!, $lineIds: [ID!], $idempotencyKey: String!) {
    commissionSaveFundingDraft(partnerId: $partnerId, lineIds: $lineIds, idempotencyKey: $idempotencyKey) {
      success
      message
      fundingBatch {
        id
        status
        invoicePresentation
        totalAmountCents
        lineCount
        issuedOn
        dueOn
        paidOn
        workdayReference
        createdAt
        partner {
          id
          name
        }
      }
    }
  }
`;
